module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-export-html"
    }
  }, [_vm._v("\n\texport html\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-560e2bf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoExportHtml.vue
// module id = 3776
// module chunks = 1